import React, { Component } from 'react';
import _ from 'lodash';

import IntelliportSensorsParkinglocationsModel from './IntelliportSensorsParkinglocationsModel';

import { Select } from 'antd';
const Option = Select.Option;

class IntelliportSensorsParkinglocationsSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {
    IntelliportSensorsParkinglocationsModel.getAll()
      .then(data => {
        data = _.sortBy(data, ['parkingLocationName']);
        var children = [];
        data.map((child, key) => {
          return children.push(<Option key={child.parkingLocationID}>{child.parkingLocationName}</Option>);
        });
        this.setState({
          children: children
        });
      });
  }

  render() {
    return (
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte lokalitu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={(value) => { this.props.onChange(value) }}
        {...this.props}>
        {this.state.children}
      </Select>
    );
  }
}

export default IntelliportSensorsParkinglocationsSelect;


// WEBPACK FOOTER //
// ./src/components/IntelliportSensorsParkinglocationsSelect.js